module.exports = __webpack_public_path__ + "static/img/74 (2).a3bf76d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/74 (2).jpg
// module id = 4+TP
// module chunks = 0